import React from 'react';
import { Stack, Text, Skeleton } from '@chakra-ui/react';
import { useSubscriptions } from 'hooks/query/useSubscriptions';
import formatNumber from 'utils/formatNumber';

const RewardsSummary: React.FC = () => {
  const { data: subscriptionsData } = useSubscriptions();
  const { subscriptionsSummary } = subscriptionsData! || {};

  const skeletonProps = {
    startColor: 'gray.500',
    endcolor: 'gray.600'
  };

  return (
    <Stack
      p={4}
      mb={4}
      borderWidth={1}
      direction={['column', null, 'row']}
      textAlign={['left', 'left', 'center']}
      justifyContent='space-around'
      borderRadius='xl'
    >
      <Text>
        Total value{' '}
        <Skeleton isLoaded={!!subscriptionsSummary} {...skeletonProps}>
          {formatNumber.currency(
            subscriptionsSummary.totalValue > 0
              ? subscriptionsSummary.totalValue
              : 0
          )}
        </Skeleton>
      </Text>
      <Text>
        Total rewards value{' '}
        <Skeleton isLoaded={!!subscriptionsSummary} {...skeletonProps}>
          {formatNumber.currency(
            subscriptionsSummary.totalRewardsValue > 0
              ? subscriptionsSummary.totalRewardsValue
              : 0
          )}
        </Skeleton>
      </Text>
      <Text>
        % of reward pool{' '}
        <Skeleton isLoaded={!!subscriptionsSummary} {...skeletonProps}>
          {formatNumber.percentLong(
            subscriptionsSummary.percentageOfRewardPool
          )}
        </Skeleton>
      </Text>
    </Stack>
  );
};

export default RewardsSummary;
